/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceSchema } from "../catalogue";

export interface CommitmentCopy {
  flowTitle: string;
  stepCounter: (args: { index: string | number; total: string | number }) => string;
  flow: {
    back: (args: { dealName: string | number }) => string;
    backFallback: string;
  };
  termStep: {
    title: string;
    subtitle: (args: { cadence: string | number }) => string;
    cta: string;
    ctaEmpty: string;
    unavailable: string;
    exitRateLabel: string;
    perAnnum: string;
    noticeLine: (args: { months: number }) => string;
    termName: (args: { months: string | number }) => string;
    noticeHelp: string;
    descriptor: (args: { months: string | number }) => string;
  };
  accountStep: {
    title: string;
    subtitle: string;
    cta: string;
    createEntityCta: string;
    personalTitle: string;
    personalDescription: string;
    isaTitle: string;
    isaBadge: string;
    isaAllowanceLeft: (args: { amount: string | number }) => string;
    isaNoAllowance: string;
    entityTitle: string;
    entityDescription: string;
    entityEmpty: string;
    addEntity: string;
    entityRejected: string;
    holdingClosed: (args: { term: string | number }) => string;
    holdingClosedGeneric: string;
    allowanceTitle: string;
    allowanceUsed: string;
    allowanceLeft: string;
  };
  switchAccount: {
    title: string;
    subtitle: string;
    cta: string;
    personalTitle: string;
    personalDescription: string;
    addEntity: string;
    error: string;
  };
  amountStep: {
    title: string;
    cta: string;
    minimum: (args: { amount: string | number }) => string;
    isaAllowance: (args: { amount: string | number }) => string;
    isaPendingMoves: (args: { amount: string | number }) => string;
    belowMinimum: (args: { amount: string | number }) => string;
    aboveMaximum: (args: { amount: string | number }) => string;
    aboveRemaining: (args: { amount: string | number }) => string;
    roundFull: string;
    aboveIsaAllowance: (args: { amount: string | number }) => string;
    aboveIsaAllowancePendingMove: (args: { amount: string | number; pending: string | number }) => string;
    roundClosedTitle: string;
    roundClosedBody: string;
    approachingLimitTitle: string;
    approachingLimitBody: string;
  };
  projection: {
    label: string;
    reinvested: string;
    paidOut: string;
    reinvestLead: string;
    paidOutLead: string;
    perYear: (args: { amount: string | number }) => string;
    accrualLabel: string;
    firstEarningsLabel: string;
    footnoteReinvested: string;
    footnotePaidOut: string;
    calculator: string;
  };
  earningsStep: {
    title: string;
    subtitle: (args: { cadence: string | number }) => string;
    cta: string;
    mostPopular: string;
    reinvestTitle: string;
    reinvestDescription: string;
    withdrawTitle: string;
    withdrawDescription: string;
    payoutHeading: string;
    payoutChange: string;
    payoutSelect: string;
    payoutAdd: string;
    payoutNone: string;
    payoutNoneForCurrency: (args: { currency: string | number }) => string;
    payoutNeedsFields: (args: { name: string | number; fields: string | number; currency: string | number }) => string;
    payoutNeedsFieldsLater: (args: { name: string | number; fields: string | number; currency: string | number }) => string;
    payoutAddFields: string;
    payoutConversion: (args: { name: string | number; accountCurrency: string | number; currency: string | number }) => string;
  };
  reviewStep: {
    title: string;
    cta: string;
    amountLabel: string;
    termLabel: string;
    accountLabel: string;
    earningsLabel: string;
    payoutLabel: string;
    noticeLabel: string;
    noticeTimingTitle: string;
    noticeTimingBody: (args: { cutOff: string | number }) => string;
    noticeTimingBodyNoDate: string;
    agreement: string;
    termValue: (args: { term: string | number; rate: string | number }) => string;
    noticeValue: (args: { months: number }) => string;
  };
  paymentStep: {
    title: string;
    summary: (args: { amount: string | number; term: string | number; rate: string | number }) => string;
    summaryAmountOnly: (args: { amount: string | number }) => string;
    cta: string;
    beforeYouPayTitle: string;
    beforeYouPayBody: string;
    automaticTitle: string;
    automaticBadge: string;
    automaticDescription: string;
    banksToggle: string;
    banksFooter: string;
    manualTitle: string;
    manualDescription: string;
  };
  successStep: {
    title: string;
    summary: (args: { amount: string | number; term: string | number; rate: string | number }) => string;
    summaryAmountOnly: (args: { amount: string | number }) => string;
    sentVia: string;
    nextHeading: string;
    confirming: (args: { amount: string | number }) => string;
    deploying: (args: { date: string | number }) => string;
    deployingNoDate: string;
    firstEarnings: (args: { date: string | number }) => string;
    cta: string;
  };
  pendingScreen: {
    title: string;
    lead: string;
    detailsHeading: string;
    accountNameLabel: string;
    sortCodeLabel: string;
    accountNumberLabel: string;
    ibanLabel: string;
    referenceLabel: string;
    callout: string;
    cta: string;
  };
  distribution: {
    cadence: (args: { frequency: string | number }) => string;
    cadenceDefault: string;
    cadenceWithMonths: (args: { cadence: string | number; months: string | number }) => string;
    cadenceWithMonthsInline: (args: { cadence: string | number; months: string | number }) => string;
  };
  capacityLabel: (args: { capacity: string | number }) => string;
  incomeDecisionLabel: (args: { decision: string | number }) => string;
}

export const commitmentSchema: NamespaceSchema = {
  namespace: "commitment",
  keys: {
    "flowTitle": [],
    "stepCounter": ["index", "total"],
    "flow.back": ["dealName"],
    "flow.backFallback": [],
    "termStep.title": [],
    "termStep.subtitle": ["cadence"],
    "termStep.cta": [],
    "termStep.ctaEmpty": [],
    "termStep.unavailable": [],
    "termStep.exitRateLabel": [],
    "termStep.perAnnum": [],
    "termStep.noticeLine": ["months"],
    "termStep.termName": ["months"],
    "termStep.noticeHelp": [],
    "termStep.descriptor": ["months"],
    "accountStep.title": [],
    "accountStep.subtitle": [],
    "accountStep.cta": [],
    "accountStep.createEntityCta": [],
    "accountStep.personalTitle": [],
    "accountStep.personalDescription": [],
    "accountStep.isaTitle": [],
    "accountStep.isaBadge": [],
    "accountStep.isaAllowanceLeft": ["amount"],
    "accountStep.isaNoAllowance": [],
    "accountStep.entityTitle": [],
    "accountStep.entityDescription": [],
    "accountStep.entityEmpty": [],
    "accountStep.addEntity": [],
    "accountStep.entityRejected": [],
    "accountStep.holdingClosed": ["term"],
    "accountStep.holdingClosedGeneric": [],
    "accountStep.allowanceTitle": [],
    "accountStep.allowanceUsed": [],
    "accountStep.allowanceLeft": [],
    "switchAccount.title": [],
    "switchAccount.subtitle": [],
    "switchAccount.cta": [],
    "switchAccount.personalTitle": [],
    "switchAccount.personalDescription": [],
    "switchAccount.addEntity": [],
    "switchAccount.error": [],
    "amountStep.title": [],
    "amountStep.cta": [],
    "amountStep.minimum": ["amount"],
    "amountStep.isaAllowance": ["amount"],
    "amountStep.isaPendingMoves": ["amount"],
    "amountStep.belowMinimum": ["amount"],
    "amountStep.aboveMaximum": ["amount"],
    "amountStep.aboveRemaining": ["amount"],
    "amountStep.roundFull": [],
    "amountStep.aboveIsaAllowance": ["amount"],
    "amountStep.aboveIsaAllowancePendingMove": ["amount", "pending"],
    "amountStep.roundClosedTitle": [],
    "amountStep.roundClosedBody": [],
    "amountStep.approachingLimitTitle": [],
    "amountStep.approachingLimitBody": [],
    "projection.label": [],
    "projection.reinvested": [],
    "projection.paidOut": [],
    "projection.reinvestLead": [],
    "projection.paidOutLead": [],
    "projection.perYear": ["amount"],
    "projection.accrualLabel": [],
    "projection.firstEarningsLabel": [],
    "projection.footnoteReinvested": [],
    "projection.footnotePaidOut": [],
    "projection.calculator": [],
    "earningsStep.title": [],
    "earningsStep.subtitle": ["cadence"],
    "earningsStep.cta": [],
    "earningsStep.mostPopular": [],
    "earningsStep.reinvestTitle": [],
    "earningsStep.reinvestDescription": [],
    "earningsStep.withdrawTitle": [],
    "earningsStep.withdrawDescription": [],
    "earningsStep.payoutHeading": [],
    "earningsStep.payoutChange": [],
    "earningsStep.payoutSelect": [],
    "earningsStep.payoutAdd": [],
    "earningsStep.payoutNone": [],
    "earningsStep.payoutNoneForCurrency": ["currency"],
    "earningsStep.payoutNeedsFields": ["name", "fields", "currency"],
    "earningsStep.payoutNeedsFieldsLater": ["name", "fields", "currency"],
    "earningsStep.payoutAddFields": [],
    "earningsStep.payoutConversion": ["name", "accountCurrency", "currency"],
    "reviewStep.title": [],
    "reviewStep.cta": [],
    "reviewStep.amountLabel": [],
    "reviewStep.termLabel": [],
    "reviewStep.accountLabel": [],
    "reviewStep.earningsLabel": [],
    "reviewStep.payoutLabel": [],
    "reviewStep.noticeLabel": [],
    "reviewStep.noticeTimingTitle": [],
    "reviewStep.noticeTimingBody": ["cutOff"],
    "reviewStep.noticeTimingBodyNoDate": [],
    "reviewStep.agreement": [],
    "reviewStep.termValue": ["term", "rate"],
    "reviewStep.noticeValue": ["months"],
    "paymentStep.title": [],
    "paymentStep.summary": ["amount", "term", "rate"],
    "paymentStep.summaryAmountOnly": ["amount"],
    "paymentStep.cta": [],
    "paymentStep.beforeYouPayTitle": [],
    "paymentStep.beforeYouPayBody": [],
    "paymentStep.automaticTitle": [],
    "paymentStep.automaticBadge": [],
    "paymentStep.automaticDescription": [],
    "paymentStep.banksToggle": [],
    "paymentStep.banksFooter": [],
    "paymentStep.manualTitle": [],
    "paymentStep.manualDescription": [],
    "successStep.title": [],
    "successStep.summary": ["amount", "term", "rate"],
    "successStep.summaryAmountOnly": ["amount"],
    "successStep.sentVia": [],
    "successStep.nextHeading": [],
    "successStep.confirming": ["amount"],
    "successStep.deploying": ["date"],
    "successStep.deployingNoDate": [],
    "successStep.firstEarnings": ["date"],
    "successStep.cta": [],
    "pendingScreen.title": [],
    "pendingScreen.lead": [],
    "pendingScreen.detailsHeading": [],
    "pendingScreen.accountNameLabel": [],
    "pendingScreen.sortCodeLabel": [],
    "pendingScreen.accountNumberLabel": [],
    "pendingScreen.ibanLabel": [],
    "pendingScreen.referenceLabel": [],
    "pendingScreen.callout": [],
    "pendingScreen.cta": [],
    "distribution.cadence": ["frequency"],
    "distribution.cadenceDefault": [],
    "distribution.cadenceWithMonths": ["cadence", "months"],
    "distribution.cadenceWithMonthsInline": ["cadence", "months"],
    "capacityLabel": ["capacity"],
    "incomeDecisionLabel": ["decision"],
  },
};
